
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "@/components/ui/table";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface WaterConsumer {
  name: string;
  accountId: string;
  type: string;
  location: string;
  usage: number;
  status: string;
}

interface AllConsumersDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  consumers: WaterConsumer[];
}

const AllConsumersDialog: React.FC<AllConsumersDialogProps> = ({ open, onOpenChange, consumers }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>All Water Consumers</DialogTitle>
          <DialogDescription>
            Complete list of all registered water consumers and their details
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead>Account ID</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Location</TableHead>
                <TableHead>Monthly Usage</TableHead>
                <TableHead>Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {consumers.map((consumer, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">{consumer.name}</TableCell>
                  <TableCell>{consumer.accountId}</TableCell>
                  <TableCell>{consumer.type}</TableCell>
                  <TableCell>{consumer.location}</TableCell>
                  <TableCell>{consumer.usage} m³</TableCell>
                  <TableCell>
                    <Badge variant={consumer.status === 'Active' ? 'default' : 'outline'}>
                      {consumer.status}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AllConsumersDialog;
